(function () {
  // ============================================
  // HELPER: refresh the cart icon bubble
  // by fetching the header section fresh
  // ============================================
  async function refreshCartBubble() {
    try {
      const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      // Fetch the header section (Maya theme renders cart-icon-bubble inside it)
      const res = await fetch(rootUrl + '?sections=header');
      if (!res.ok) return;
      const sections = await res.json();

      const headerHTML = sections.header;
      if (!headerHTML) {
        console.warn('Header section returned empty');
        return;
      }

      // Parse the new header HTML
      const tmp = document.createElement('div');
      tmp.innerHTML = headerHTML;

      // Find both cart-icon-bubble and mobile-cart-icon-bubble inside it
      ['cart-icon-bubble', 'mobile-cart-icon-bubble'].forEach(function (id) {
        const newEl = tmp.querySelector('#' + id);
        const oldEl = document.getElementById(id);
        if (newEl && oldEl) {
          oldEl.innerHTML = newEl.innerHTML;

          // Sync the is-empty-cart class on the inner link
          const newLink = newEl.querySelector('[data-cart-icon-bubble]');
          const oldLink = oldEl.querySelector('[data-cart-icon-bubble]');
          if (newLink && oldLink) {
            oldLink.className = newLink.className;
          }
        }
      });
    } catch (err) {
      console.warn('Cart bubble refresh failed:', err);
    }
  }

  // Expose globally
  window.refreshCartBubble = refreshCartBubble;

  // ============================================
  // SITE-WIDE: intercept ANY cart mutation
  // ============================================
  const CART_MUTATION_PATHS = ['/cart/add', '/cart/change', '/cart/update', '/cart/clear'];

  function isCartMutation(url) {
    if (!url) return false;
    const s = String(url);
    return CART_MUTATION_PATHS.some(function (p) { return s.indexOf(p) !== -1; });
  }

  const originalFetch = window.fetch;
  window.fetch = function () {
    const url = arguments[0];
    const isCart = isCartMutation(typeof url === 'string' ? url : (url && url.url));
    const result = originalFetch.apply(this, arguments);
    if (isCart) {
      result.then(function (response) {
        if (response.ok) setTimeout(refreshCartBubble, 150);
      }).catch(function () {});
    }
    return result;
  };

  const originalXHROpen = XMLHttpRequest.prototype.open;
  const originalXHRSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._cartSyncUrl = url;
    return originalXHROpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    const xhr = this;
    if (isCartMutation(xhr._cartSyncUrl)) {
      xhr.addEventListener('load', function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          setTimeout(refreshCartBubble, 150);
        }
      });
    }
    return originalXHRSend.apply(this, arguments);
  };

  // Native form submits on the /cart page
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (form && form.action && isCartMutation(form.action)) {
      setTimeout(refreshCartBubble, 600);
    }
  });

  // ============================================
  // CARD INLINE ATC LOGIC (unchanged)
  // ============================================
  function positionDropdown(dropdown) {
    const menu = dropdown.querySelector('[data-card-dropdown-menu]');
    if (!menu) return;

    // Always open the size menu upward
    menu.style.top = 'auto';
    menu.style.bottom = 'calc(100% + 4px)';
  }

  function bindCardForms() {
    document.querySelectorAll('[data-card-form]').forEach(function (form) {
      if (form.dataset.bound === 'true') return;
      form.dataset.bound = 'true';

      const hiddenId = form.querySelector('[data-card-variant-id]');
      const dropdown = form.querySelector('[data-card-dropdown]');

      if (dropdown && hiddenId) {
        const toggle = dropdown.querySelector('[data-card-dropdown-toggle]');
        const label = dropdown.querySelector('[data-card-dropdown-label]');
        const items = dropdown.querySelectorAll('.card-size-dropdown-item');

        toggle.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          document.querySelectorAll('.card-size-dropdown.is-open').forEach(function (d) {
            if (d !== dropdown) d.classList.remove('is-open');
          });

          dropdown.classList.toggle('is-open');
          toggle.setAttribute('aria-expanded', dropdown.classList.contains('is-open'));

          if (dropdown.classList.contains('is-open')) {
            positionDropdown(dropdown);
          }
        });

        items.forEach(function (item) {
          item.addEventListener('click', function (e) {
            e.stopPropagation();
            if (item.classList.contains('is-disabled')) return;

            items.forEach(function (i) { i.classList.remove('is-selected'); });
            item.classList.add('is-selected');

            label.textContent = item.dataset.value;
            hiddenId.value = item.dataset.variantId;

            dropdown.classList.remove('is-open');
            toggle.setAttribute('aria-expanded', 'false');
          });
        });
      }

      form.addEventListener('submit', async function (e) {
        e.preventDefault();
        const btn = form.querySelector('[data-card-atc]');
        const btnText = form.querySelector('[data-card-atc-text]');
        if (!btn || !btnText) return;

        const original = btnText.textContent;
        btn.disabled = true;
        btnText.textContent = 'Adding...';

        try {
          const formData = new FormData(form);
          const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

          // --- Re-enable the "Item added to cart" popup ---
          const cartNotification = document.querySelector('cart-notification');
          if (cartNotification && typeof cartNotification.getSectionsToRender === 'function') {
            const ids = cartNotification.getSectionsToRender().map(function (s) { return s.id; });
            formData.append('sections', ids.join(','));
            formData.append('sections_url', window.location.pathname);
          }

          const res = await fetch(rootUrl + 'cart/add.js', {
            method: 'POST',
            body: formData,
            headers: { Accept: 'application/json' }
          });

          if (!res.ok) {
            const err = await res.json().catch(function () { return {}; });
            throw new Error(err.description || 'Add to cart failed');
          }

          const parsedState = await res.json();

          // Trigger the theme's popup using its own render logic
          if (cartNotification && typeof cartNotification.renderContents === 'function') {
            cartNotification.renderContents(parsedState);
          } else if (cartNotification && typeof cartNotification.open === 'function') {
            cartNotification.open();
          }

          btnText.textContent = '✓ Added';

          // The fetch interceptor also refreshes — call here as a safety net
          await refreshCartBubble();

          setTimeout(function () {
            btn.disabled = false;
            btnText.textContent = original;
          }, 1500);
        } catch (err) {
          console.error('Card add to cart error:', err);
          btnText.textContent = 'Item is Sold Out';
          setTimeout(function () {
            btn.disabled = false;
            btnText.textContent = original;
          }, 2000);
        }
      });
    });
  }

  document.addEventListener('click', function () {
    document.querySelectorAll('.card-size-dropdown.is-open').forEach(function (d) {
      d.classList.remove('is-open');
      const t = d.querySelector('[data-card-dropdown-toggle]');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindCardForms);
  } else {
    bindCardForms();
  }

  document.addEventListener('shopify:section:load', bindCardForms);
  document.addEventListener('collection:filtered', bindCardForms);
})();